document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Vars
   *******************************/
  const body = document.querySelector('body');

  /********************************
   * Accordion
   *******************************/
  const accordionGroup = document.querySelectorAll('.accordion-wrap');

  if (accordionGroup.length >= 1) {
    accordionGroup.forEach(accordion => {
      if (accordion.classList.contains('open-first-child')) {
        setTimeout(() => {
          const accordionItem = accordion.querySelector('.accordion-item');
          const accordionContent = accordionItem.querySelector('.accordion-description');

          accordionItem.classList.add('active');
          accordionContent.style.height = (accordionContent.querySelector('.accordion-inner-content').scrollHeight + 30) + "px";
        }, 1300)
      }

      accordion.addEventListener('click', function ({target}) {
        const accordionActive = accordion.querySelector('.accordion-item.active');
        const accordionItem = target.closest('.accordion-item');
        const accordionContent = accordionItem.querySelector('.accordion-description');

        if (accordionItem.classList.contains('active')) {
          accordionItem.classList.remove('active');
          accordionContent.style.height = 0 + 'px';
        } else {
          if (accordionActive) {
            accordionActive.classList.remove('active');
            accordionActive.querySelector('.accordion-description').style.height = 0 + 'px';
          }

          accordionItem.classList.add('active');
          accordionContent.style.height = (accordionContent.querySelector('.accordion-inner-content').scrollHeight + 30) + "px";
        }
      });
    })
  }

  /********************************
   * Popup (section feature product, ingredients popup)
   *******************************/
  const ingredientsPopup = document.querySelector('.feature-product .popup-wrapper');
  const triggerPopup = document.querySelector('.feature-product .trigger-popup');

  if(ingredientsPopup && triggerPopup){
    const buttonHidePopup = ingredientsPopup.querySelector('.btn-close');
    const popupOverlay = ingredientsPopup.querySelector('.popup-overlay');

    triggerPopup.addEventListener('click', ()=> {
      ingredientsPopup.classList.add('show');
    });

    buttonHidePopup.addEventListener('click', ()=> ingredientsPopup.classList.remove('show'));
    popupOverlay.addEventListener('click', ()=> ingredientsPopup.classList.remove('show'));
  }

  /********************************
   * Section feature: slider
   *******************************/
  const mainSlider = document.querySelector('#main-slider_init');

  if(mainSlider && !mainSlider.classList.contains('single-slide')){
    const thumbsSlider = document.querySelector('#thumbs-slider_init');

    const featureSliderThumbs = new Swiper(thumbsSlider, {
      slidesPerView: 4,
      breakpoints: {
        992: {
          slidesPerView: 4,
        }
      }
    });

    const featureSliderMain = new Swiper(mainSlider, {
      spaceBetween: 10,
      thumbs: {
        swiper: featureSliderThumbs,
      },
      navigation: {
        nextEl: ".slider-nav-next",
        prevEl: ".slider-nav-prev",
      },
    });
  }

  /********************************
   * Section: how it work
   *******************************/
  const howItWorkSection = document.querySelector('.how-it-work');

  if(howItWorkSection) {
    const slider = howItWorkSection.querySelector('.how-it-work_init');
    if (!slider) return false;

    const swiper = new Swiper(slider, {
      effect: "fade",
      slidesPerView: 1,
      allowSlidePrev: false,
      navigation: {
        nextEl: ".swiper-button-next",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
      on: {
        slideChange: function () {
          const totalSlides = this.slides.length - 1;
          const currentSlide = this.activeIndex;

          const buttonNavigation = slider.querySelector('.button-navigation');

          if (currentSlide === totalSlides) {
            buttonNavigation.classList.add('show-link');
          }
        },
      },
    });
  }

  /********************************
   * Section Video
   *******************************/
  const videoSection = document.querySelectorAll('.video-wrap');

  if(videoSection.length){
    videoSection.forEach(videoBox  =>{
      videoBox.addEventListener('click', ({target})=>{
        if(target.classList.contains('play-video')){
          const video = videoBox.querySelector('.media-video');
          if(!video) return false;
          video.play();
          videoBox.classList.add('video-played');
        }
      })
    })
  }

  /********************************
   * Link to Checkout
   *******************************/
  const checkoutLinks = document.querySelectorAll('.checkout-url');

  if (checkoutLinks.length) {
    checkoutLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        let href = link.dataset.href;

        if (window.free_gift_settings.action && window.free_gift_settings.product != false) {
          href = href.replace('return_to=/checkout', `items[1][id]=${window.free_gift_settings.product}%26items[1][quantity]=1%26return_to=/checkout`);
          window.location.href = href;
        }else {
          window.location.href = link.dataset.href;
        }
      })
    });
  }

  /********************************
   * Klaviyo Form
   *******************************/
  const klaviyoFormWrap = document.querySelector('.klaviyo-form');
  if(klaviyoFormWrap){
    const listId = klaviyoFormWrap.dataset.list;
    const companyId = klaviyoFormWrap.dataset.companyId;
    const klaviyoForm = klaviyoFormWrap.querySelector('form');
    const klaviyoFormError = klaviyoFormWrap.querySelector('.subscribe-error');
    const klaviyoFormSuccessful = klaviyoFormWrap.querySelector('.subscribe-successful');

    function submitKlaviyoForm(e) {
      e.preventDefault();
      const emailInput = klaviyoForm.querySelector('.input-email');
      if (!emailInput.value) return;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+companyId, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-07-15'
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: emailInput.value,
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: listId
                }
              }
            }
          }
        })
      })
      .then(function(response) {
        return response.text();
      })
      .then(function(data) {
        console.log(`data, ${data}`);
        emailInput.value = '';
        klaviyoFormSuccessful.style.display = 'block'
      })
      .catch(function(error) {
        console.error('Error:', error);
        klaviyoFormError.style.display = 'block'
      });
    }

    klaviyoForm.addEventListener('submit', submitKlaviyoForm);
  }

  /********************************
   * Section: Banner reviews slider
   *******************************/
  const bannerReviewsSection = document.querySelector('.section-banner-reviews');

  if(bannerReviewsSection) {
    const slider = bannerReviewsSection.querySelector('.banner-reviews_init');
    if (!slider) return false;

    const swiper = new Swiper(slider, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      autoHeight: true,
      allowSlidePrev: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
      },
    });

    const pseudoSwiperButton = bannerReviewsSection.querySelectorAll('.pseudo-swiper-button');
    const swiperButtonNext = bannerReviewsSection.querySelector('.swiper-button-next');
    pseudoSwiperButton.forEach(button => button.addEventListener('click', () => swiperButtonNext.click()));
  }
});